import { FC } from 'react';
import { XAxis, YAxis, CartesianGrid, Tooltip, Area, ComposedChart, ReferenceLine, ResponsiveContainer, Line } from 'recharts';
import { IDatedValues } from '../../components/PairSpreadItem/PairSpreadItem';

export interface IReferenceLine {
    value: number;
    label: string;
    color: string;
}

export interface IChartProps {
    data: IDatedValues[];
    width: number;
    height: number;
    nameAxisX: string;
    nameAxisY: string;
    xFormatter: (label: number) => string;
    yFormatter?: (value: number) => string;
    yFormatterLabel?: (value: number) => string;
    fitAxisY: boolean;
    reference?: IReferenceLine;
}

export const Chart: FC<IChartProps> = ({ data, width, height, nameAxisX, nameAxisY, xFormatter, yFormatter, yFormatterLabel, fitAxisY, reference }) => {
        
    return (
        <ResponsiveContainer width="100%" height={300}>
            <ComposedChart width={ width } height={ height } data={data} margin={{top: 5, right: 0, left: -21, bottom: 25}}>
                <defs>
                <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#063970" stopOpacity={0.7}/>
                    <stop offset="95%" stopColor="#fff" stopOpacity={0.2}/>
                </linearGradient>
                </defs>
                <XAxis
                    dataKey={ nameAxisX }
                    tickFormatter={label => xFormatter(label)}
                    tickLine={ false }
                    axisLine={ false }
                    tickMargin={ 12 }
                    minTickGap={ 20 }
                    style={{
                        fontSize: '13px'
                    }} />
                <YAxis
                    tickFormatter={ yFormatter }
                    tickMargin={ 8 }
                    axisLine={ false }
                    style={{
                        fontSize: '13px'
                    }}
                    domain={ fitAxisY ? ['auto', 'auto'] : [0, 'auto'] } />
                <Tooltip
                    labelStyle={{
                        color: '#fff',
                        fontSize: '12px',
                        fontWeight: 600
                    }}
                    itemStyle={{
                        color: '#fff',
                        fontSize: '12px',
                        fontWeight: 600,
                    }}
                    contentStyle={{
                        backgroundColor: '#888888',
                        borderColor: '#555555',
                        padding: '4px 6px 4px 8px',
                        borderRadius: '3px'
                    }}
                    separator={''}
                    formatter={ value => [yFormatterLabel ? yFormatterLabel(value as any) : value, ""] }
                    labelFormatter={
                        value => [xFormatter(value), ""]
                    }
                    />
                <CartesianGrid
                    stroke="#ddd"
                    strokeWidth={0.25} />
                
                <Area type="monotone" connectNulls={false} dataKey={ nameAxisY } strokeWidth={2} fillOpacity={1} fill="url(#colorUv)" stroke={'#063970'} strokeOpacity={0.7} />  
                

            </ComposedChart>
        </ResponsiveContainer>
    );
}
